const messages = {
  payoutsDescription: "List of paid out BS+ items.",
  paidOut: "paid out",
  makeChoice: "Faceți alegerea dvs. aici.",
  seeAll: "Vezi tot",
  clear: "Șterge",
  back: "Înapoi",
  save: "Salvează",
  close: "Închide",
  of: "Din",
  to: "La",
  copyrights: "© {date} Bridgestone Solutions. Toate drepturile rezervate.",
  pageNotFound: "Pagină nu găsită",
  accessDenied: "Acces refuzat",
  search: "Căutare",
  year: "An",
  buttons: {
    loading: "Se încarcă...",
    export: "Exportă",
    delete: "Șterge",
    save: "Salvează",
    cancel: "Anulează",
    next: "Următorul",
    back: "Înapoi",
    skip: "Sari",
    send: "Trimite",
    readNow: "Citeste acum",
    pointsList: "Lista de puncte",
    clear: "Șterge",
    more: "Mai mult",
    close: "Închide",
    reportError: "Raportați eroare",
    accept: "Accepta",
    download: "Descarcă",
    downloadAll: "Descarcă tot",
    selectAll: "Selectează tot",
    deselectAll: "Deselectează tot",
    downloadSelection: "Descarcă selecția",
    dealerInfoDownload: "Descarcă",
    toTheBasket: "În coș",
    toOrderDelivery: "Continuă la adresa de livrare",
    discover: "Descoperă",
    newAddress: "Creează adresă nouă de livrare",
    selectAddressBtn: "Selectează adresa de livrare",
    toOrderSummary: "La prezentarea comenzii",
    placeOrder: "Comandă obligatorie",
    toDashboard: "La pagina principală",
    newOrder: "Comandă nouă",
    userOrders: "La comenzile tale",
    toSearch: "Căutare",
    select: "Selectează",
    moreCustomerNumbers: "+ ADAUGĂ MAI MULTE NUMERE DE CLIENT",
    loadMore: "Încarcă mai mult",
    toStaffDashboard: "La panou",
    toQuiz: "La quiz",
    vouchers: "Vouchere",
    exchangeVoucher: "Răscumpără cod voucher",
    confirm: "Confirmă",
    sharePoints: "Partajează puncte",
    create: "Creează",
    update: "Actualizează",
    toBDrive: "La B-Drive",
    preview: "Previzualizare",
    clickHere: "Vezi detalii",
    setFilters: "Vă rugăm să setați <b>maximum un filtru pe coloană</b>",
    all: "Toate",
  },
  tooltips: {
    info: "Ai nevoie de ajutor?",
  },
  confirmation: {
    header: "Confirmare necesară",
    message: "Dorești să ștergi această intrare?",
  },
  nav: {
    consents: "Consimțăminte",
    dashboard: "Acasă",
    accountDashboard: "Panou",
    account: "Profilul meu",
    mailbox: "Mesaje primite",
    singleMailbox: "Mesaje",
    stammdaten: "Date principale",
    news_feeds: "Ştiri",
    pointsOverview: "Prezentare puncte",
    rewardsOverview: "Prezentare puncte",
    about: "Despre BS Plus",
    service_number: "Contact",
    shop: "Magazin de recompense",
    salesPromotions: "Promoții de vânzări",
    promotions: "Contul meu",
    shopCategory: "Magazin de recompense",
    productDetails: "Detalii produs",
    userOrders: "Comenzi utilizator",
    shoppingCart: "Coș de cumpărături",
    orderDelivery: "Adresă de livrare",
    orderSummary: "Prezentare comandă",
    orderComplete: "Comandă finalizată",
    text_page: "Pagină statică",
    staff: "Panou de service",
    onlineTrainings: "Traininguri online",
    trainings: "Traininguri",
    training: "Training",
    trainingForm: "Formular training",
    staffVouchers: "Vouchere",
    wholesalerVouchers: "Vouchere",
    brochure_prices: "Liste de prețuri și broșuri",
    investment: "Sprijin pentru investitii",
    media: "Media",
    medias: "Media",
    contact_service: "Informații și Serviciu Contact",
    productInfo: "INFORMAȚII DESPRE PRODUS",
    bDrive: "Imagini produse",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condiții de participare",
    first_stop: "Garanția anvelopelor Bridgestone",
    payouts: "Payouts",
},
  breadcrumbs: {
    dashboard: "Acasă",
    accountDashboard: "Panou",
    account: "Profilul meu",
    mailbox: "Mesaje primite",
    singleMailbox: "Mesaje",
    stammdaten: "Date principale",
    news_feeds: "Ştiri",
    pointsOverview: "Prezentare puncte",
    rewardsOverview: "Prezentare puncte",
    about: "Despre BS Plus",
    service_number: "Contact",
    shop: "Magazin de recompense",
    salesPromotions: "Promoții de vânzări",
    promotions: "Contul meu",
    shopCategory: "Magazin de recompense",
    productDetails: "Detalii produs",
    userOrders: "Comenzi utilizator",
    shoppingCart: "Coș de cumpărături",
    orderDelivery: "Adresă de livrare",
    orderSummary: "Prezentare comandă",
    orderComplete: "Comandă finalizată",
    staff: "Panou de service",
    onlineTrainings: "Traininguri online",
    trainings: "Traininguri",
    training: "Training",
    trainingForm: "Formular training",
    staffVouchers: "Vouchere",
    wholesalerVouchers: "Vouchere",
    brochure_prices: "Liste de prețuri și broșuri",
    investment: "Sprijin pentru investitii",
    media: "Media",
    medias: "Media",
    contact_service: "Informații și Serviciu Contact",
    productInfo: "INFORMAȚII DESPRE PRODUS",
    bDrive: "Imagini produse",
    touch_incentive: "Contact Touch Incentive",
    commitment_letter: "Condiții de participare",
    first_stop: "Garanția anvelopelor Bridgestone",
    payouts: "Payouts",
},
  menu: {
    account: "Profilul meu",
    plus: 'Despre Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Suport Vânzări",
    mailbox: "Mesaje primite",
    about: "Despre BS Plus",
    trainingAndCourses: "Training și Cursuri",
    externalTraining: "Training Extern",
    productInfo: "Informații despre Produse",
    productBrochures: "Broșuri Produse",
    priceLists: "Liste de Prețuri",
    price: "Preț",
    complaintForm: "Formular de Reclamație",
    sales_support: "Suport Vânzări",
    contact_service: "Informații și Serviciu Contact",
    logOut: "Deconectează-te",
    news: "Știri",
    news_feeds: "Ştiri",
    service_number: "Contact",
    salesPromotions: "Promoții de vânzări",
    shop: "Magazin",
    onlineTrainings: "Traininguri online",
    trainings: "Traininguri",
    brochure_prices: "Liste de prețuri și broșuri",
    media: "Media",
    medias: "Media",
    stammdaten: "Date principale",
    preislisten: "Liste de Prețuri",
  },
  validation: {
    requiredField: "Câmp obligatoriu",
  },
  sortBy: {
    default: "Sortează după",
    desc: "Sortează după: Cele mai noi",
    asc: "Sortează după: Cele mai vechi",
    name: "Nume",
    date: "Data",
    choiceBy: "Sortează",
  },
  month: {
    1: "ianuarie",
    2: "februarie",
    3: "martie",
    4: "aprilie",
    5: "mai",
    6: "iunie",
    7: "iulie",
    8: "august",
    9: "septembrie",
    10: "octombrie",
    11: "noiembrie",
    12: "decembrie",
  },
};


export default {
  messages,
};
